import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ThresholdItem } from './widget-thresholds-modal.model';

@Injectable({
    providedIn: 'root'
})
export class WidgetThresholdsModalService {

    constructor(
        public cvApiService: CVApiService,
    ) { }

    async loadWidgetThresholds(moduleKey: string) {
        const response = await this.cvApiService.get<Record<string, ThresholdItem[]>>(`/api/v2/widget-thresholds/${moduleKey}`);
        if (response.status_code === 200)
            return response.data;
        throw response;
    }

    async saveWidgetThresholds(moduleKey: string, metricThresholds: Record<string, ThresholdItem[]>) {
        const response = await this.cvApiService.post<boolean>(
            `/api/v2/widget-thresholds/${moduleKey}?=metricThresholds`, metricThresholds);
        if (response.status_code === 200)
            return response.data;
        throw response;
    }
}


